export const setPickStatusColor = (fillPercentage: number): string => {
  let color = '';

  switch (fillPercentage) {
    case 100:
      color = '#4BBD64';
      break;
    case 0:
      color = '#DD1D1D';
      break;
    default:
      color = '#FFBF00';
      break;
  }
  return color;
};
